<div class="tab-strip" [class.tab-strip-vertical]="orientation() === 'vertical'">
  <div class="tab-strip-tabs" role="tablist" [attr.aria-orientation]="orientation()">
    @for (tab of tabs(); track tab.id()) {
    <button type="button" class="tab-strip-tab" [class.tab-strip-tab-active]="selected() === tab.id()" role="tab"
      [attr.aria-selected]="selected() === tab.id()" [attr.aria-controls]="'panel-' + tab.id()"
      [attr.data-testid]="'tab-' + tab.id()" (click)="selectTab(tab.id())">
      @if (tab.tabLabelTemplate(); as tabLabelTemplate) {
      <ng-container [ngTemplateOutlet]="tabLabelTemplate" />
      } @else {
      {{ tab.label() }}
      }
    </button>
    }
  </div>

  <div class="tab-strip-panels">
    <ng-content />
  </div>
</div>